/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { DivBackgroundOpacity } from "@utils/extra-style";

const GeneralInfo = (props) => {
  const { t, data, column } = props;
  return (
    <>
      <DivBackgroundOpacity opacity={data.status ? "1" : "0.2"}>
        {column === "id" && <div>{data.id}</div>}
        {column === "label" && <div>{data.label}</div>}
        {column === "calculationRate" && <div>{data.calculationRate}</div>}
      </DivBackgroundOpacity>
    </>
  );
};

GeneralInfo.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
};

GeneralInfo.defaultProps = {
  page: null,
};

export default withTranslation()(GeneralInfo);
